var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as S from './styles';
export var Container = forwardRef(function Container(_a, ref) {
    var alignItems = _a.alignItems, bordered = _a.bordered, inline = _a.inline, _b = _a.as, as = _b === void 0 ? inline ? 'span' : 'div' : _b, children = _a.children, direction = _a.direction, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right, padded = _a.padded, justifyContent = _a.justifyContent, flex = _a.flex, fullWidth = _a.fullWidth, className = _a.className, style = _a.style, rest = __rest(_a, ["alignItems", "bordered", "inline", "as", "children", "direction", "top", "bottom", "left", "right", "padded", "justifyContent", "flex", "fullWidth", "className", "style"]);
    var margins = __assign(__assign(__assign(__assign({}, (typeof top === 'number' && { marginTop: top + "rem" })), (typeof bottom === 'number' && { marginBottom: bottom + "rem" })), (typeof left === 'number' && { marginLeft: left + "rem" })), (typeof right === 'number' && { marginRight: right + "rem" }));
    var marginLeftClassName = typeof left === 'string' && "left-" + left + "-margin";
    var marginRightClassName = typeof right === 'string' && "right-" + right + "-margin";
    var marginTopClassName = typeof top === 'string' && "top-" + top + "-margin";
    var marginBottomClassName = typeof bottom === 'string' && "bottom-" + bottom + "-margin";
    var paddingClassName = typeof padded === 'string' && padded + "-padding";
    var inlineClassName = inline ? 'inline' : false;
    var flexClassName = flex ? 'flex' : false;
    var fullWidthClassName = fullWidth ? 'full-width' : false;
    var alignItemsClassName = typeof alignItems === 'string' && alignItems + "-align-items";
    var justifyContentClassName = typeof justifyContent === 'string' && justifyContent + "-justify-content";
    var directionClassName = typeof direction === 'string' && direction + "-direction";
    var borderedClassName = bordered ? 'bordered' : false;
    var rootClass = cx(className, marginLeftClassName, marginRightClassName, marginTopClassName, marginBottomClassName, paddingClassName, inlineClassName, flexClassName, fullWidthClassName, alignItemsClassName, justifyContentClassName, directionClassName, borderedClassName);
    return (React.createElement(S.Container, __assign({ as: as, className: rootClass, style: __assign(__assign(__assign({}, margins), (typeof padded === 'number' && { padding: padded + "rem" })), style) }, rest, { ref: ref }), children));
});
Container.defaultProps = {
    inline: false,
    fullWidth: false
};
Container.displayName = 'Container';
export default Container;
//# sourceMappingURL=Container.js.map